export default "__VITE_ASSET__CoRllFrt__"